import { render, staticRenderFns } from "./CreateAnswer.vue?vue&type=template&id=18a031a0&scoped=true"
import script from "./CreateAnswer.vue?vue&type=script&lang=js"
export * from "./CreateAnswer.vue?vue&type=script&lang=js"
import style0 from "./CreateAnswer.vue?vue&type=style&index=0&id=18a031a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a031a0",
  null
  
)

export default component.exports